/***
 *
 *   APP LAYOUT
 *   Main application layout containing the navigation
 *   and header (title, secondary nav and signed in user)
 *
 *   PROPS
 *   title: title of the view
 *
 **********/

import { Fragment, useContext, type ComponentType } from 'react';
import { AuthContext, AppNav, Header, User } from 'components/lib';
import { useLocation } from 'react-router-dom';

interface AppLayoutProps {
  title: string;
  children: ComponentType<Record<string, unknown>>;
  data?: Record<string, unknown>;
}

export function AppLayout(props: AppLayoutProps) {
  // context & style
  const context = useContext(AuthContext);
  const location = useLocation();
  const headerStatus =
    location.pathname.includes('/projects/add') ||
    location.pathname.includes('/grids/add') ||
    (location.pathname.includes('/grids/') && location.pathname.includes('/review')) ||
    location.pathname.includes('/geodatas/add') ||
    (location.pathname.includes('/geodatas/') && location.pathname.includes('/review')) ||
    location.pathname.includes('/simulations/add') ||
    (location.pathname.includes('/simulations/') && location.pathname.includes('/review'));

  return (
    <Fragment>
      <AppNav
        items={[
          { label: 'Dashboard', icon: 'dashboard', link: '/dashboard' },
          { label: 'Account', icon: 'user', link: '/account' },
          {
            label: 'Guide',
            icon: 'guide',
            action: () => window.open('https://urbanmetrix.com/guide', '_blank', 'noopener,noreferrer'),
          },
          { label: 'Logout', icon: 'logout', action: context.signout },
          {
            label: 'Support',
            icon: 'support',
            position: 'bottom',
            action: () => {
              const trigger = document.querySelector<HTMLElement>('.report-issue-trigger');
              const widget = document.querySelector<HTMLElement>('.report-issue-widget');

              if (widget) {
                widget.style.left = '20px';
                widget.style.bottom = '16px';
                widget.style.right = 'auto';
                widget.style.top = 'auto';
                widget.style.alignItems = 'flex-start';
              }

              if (trigger && !document.querySelector('.report-issue-panel')) {
                trigger.click();
              }
            },
          },
        ]}
      />

      {/* <main
        // className={Style.app}
        id='main'
      >
        {pathname.includes('/projects/add') ||
        pathname.includes('/grids/add') ||
        pathname.includes('/geodatas/add') ||
        pathname.includes('/simulations/add') ? (
          <></>
        ) : (
          <Header
            title={props.title}
            id='main-header'
          >
            <User />
          </Header>
        )}

        {
          <div id='main-content'>
            <props.children {...props.data} />
          </div>
        }
      </main> */}

      <main
        // className={Style.app}
        id="main"
      >
        {headerStatus ? (
          <></>
        ) : (
          <Header title={props.title} id="main-header">
            <User />
          </Header>
        )}

        {
          <div id="main-content" style={headerStatus ? { height: '90vh' } : {}}>
            <props.children {...props.data} />
          </div>
        }
      </main>
    </Fragment>
  );
}
